import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { Button } from "@design-system/Button/Button";
import { useViewOnlyTooltipReason } from "@hooks/permissions/useViewOnlyTooltipReason";
import { MEMBER_RESTRICTION_TOOLTIP } from "./constants";

interface Props {
    canEditCoA: boolean;
    onOpen: () => void;
    variant?: "primary" | "secondary";
    isDisabled?: boolean;
}

export const EditChartOfAccountsButton = ({
    canEditCoA,
    onOpen,
    variant = "primary",
    isDisabled = false,
}: Readonly<Props>) => {
    const tooltipReason = useViewOnlyTooltipReason(MEMBER_RESTRICTION_TOOLTIP);
    return (
        <Tooltip disabled={canEditCoA} content={tooltipReason}>
            <Button
                variant={variant}
                size="md"
                disabled={!canEditCoA || isDisabled}
                onClick={onOpen}
            >
                Edit Chart of Accounts
            </Button>
        </Tooltip>
    );
};
